'use strict';

/**
 * Normalise a filter query-string value so that + characters (which browsers
 * put in URL-encoded query params) are treated the same as %20 (space).
 * #15 fix: business users copy-paste params from the PLP URL, which may use
 * + for spaces, but the comparison expects %20.
 *
 * @param {string} str - The raw filter value string to normalise
 * @returns {string} The normalised string with + replaced by %20
 */
function normaliseFilterValue(str) {
    return str ? String(str).replace(/\+/g, '%20') : str;
}

/**
 * Normalise all parameter values in a URLSearchParams or raw query-string.
 * @param {string} rawFilter - The raw filter query string (may contain &amp; or + encoding)
 * @returns {URLSearchParams} A URLSearchParams instance with all values normalised
 */
function buildNormalisedParams(rawFilter) {
    var qs = (rawFilter || '').replace(/&amp;/g, '&');
    var params = new URLSearchParams(qs);
    var normalised = new URLSearchParams();
    params.forEach(function (value, key) {
        normalised.set(key, normaliseFilterValue(value));
    });
    return normalised;
}

function markAsInvalidFilter($filterButton) {
    $filterButton.addClass('invalid-filters').prop('disabled', true);
    window.console.error('The filter button has incorrect filter format. ', $filterButton.data('filter'));
}

var FILTER_BTN_SELECTOR = '[data-filter-button], [data-custom-filter-button]';

function getFilterButtons() {
    var filterButtons = [];
    $(FILTER_BTN_SELECTOR)
        .removeClass('invalid-filters')
        .prop('disabled', false)
        .each(function () {
            var $btn = $(this);
            var filterData = $btn.data('filter');
            var filterObj = {};

            try {
                // #15 fix: normalise before parsing
                var separatedFilters = filterData.replace(/\+/g, '%20').split('&');

                if (separatedFilters.length > 1) {
                    for (var i = 0; i < separatedFilters.length / 2; i++) {
                        var prefn;
                        var prefv;

                        for (var j = 0; j < separatedFilters.length; j++) {
                            var separatedFilter = separatedFilters[j];
                            if (separatedFilter.startsWith('prefn' + (i + 1) + '=')) {
                                prefn = separatedFilter.split('=')[1];
                            } else if (separatedFilter.startsWith('prefv' + (i + 1) + '=')) {
                                prefv = separatedFilter.split('=')[1];
                            }
                        }

                        if (prefn && prefv) {
                            filterObj[prefn] = prefv.split('%7C');
                        }
                    }

                    filterButtons.push(filterObj);
                } else {
                    markAsInvalidFilter($btn);
                }
            } catch (e) {
                markAsInvalidFilter($btn);
            }
        });

    return filterButtons;
}

function handleFilterButtonsDisable() {
    var filterButtonsData = getFilterButtons();
    if (!filterButtonsData.length) {
        return;
    }

    $(FILTER_BTN_SELECTOR + ':not(.invalid-filters)').each(function (i, filterButton) {
        $(filterButton).prop('disabled', false);

        var refinementIds = [];
        var refinementValues = [];

        $('.js_custom-refinement').each(function () {
            var $refinement = $(this);
            refinementIds.push($refinement.data('refinement-id'));
            refinementValues.push(normaliseFilterValue($refinement.data('refinement-value') || ''));
        });

        var filterData = filterButtonsData[i];
        var allKeysMatched = Object.keys(filterData).every(function (key) {
            return refinementIds.includes(key);
        });

        if (!allKeysMatched) {
            $(filterButton).prop('disabled', true);
            return;
        }

        var allValuesMatched = Object.keys(filterData).every(function (key) {
            var filterValues = filterData[key];
            return filterValues.every(function (value) {
                return refinementValues.includes(normaliseFilterValue(value));
            });
        });

        if (!allValuesMatched) {
            $(filterButton).prop('disabled', true);
        }
    });
}

/**
 * #8 fix: update aria-label based on selected/deselected state
 * #5 fix: aria-pressed is set correctly on state change
 * @param {jQuery} $btn - The filter button jQuery element
 * @param {boolean} isSelected - Whether the button is in the selected/active state
 */
function setButtonAriaState($btn, isSelected) {
    $btn.toggleClass('selected', isSelected).attr('aria-pressed', isSelected);
    var label = isSelected ? $btn.data('label-on') : $btn.data('label-off');
    if (label) {
        $btn.attr('aria-label', label);
    }
}

/**
 * #2 fix: correct comparison — a button is "selected" if and only if the URL
 * has exactly the same set of filter params as the button (no more, no less).
 */
function updateFilterButtonStates() {
    var selectedFilters = new URLSearchParams(window.location.search);

    // Collect all active prefn/prefv pairs from the URL
    var activeFilterKeys = {};
    selectedFilters.forEach(function (value, key) {
        if (key.startsWith('prefn') || key.startsWith('prefv')) {
            activeFilterKeys[key] = normaliseFilterValue(value);
        }
    });

    $(FILTER_BTN_SELECTOR).each(function () {
        var $btn = $(this);
        var buttonFilter = $btn.data('filter');

        if (!buttonFilter) {
            setButtonAriaState($btn, false);
            return;
        }

        var buttonParams = buildNormalisedParams(buttonFilter);

        // #2 fix: count filter-relevant params in the URL
        var urlFilterParamCount = Object.keys(activeFilterKeys).length;
        var btnFilterParamCount = 0;
        buttonParams.forEach(function (value, key) {
            if (key.startsWith('prefn') || key.startsWith('prefv')) {
                btnFilterParamCount++;
            }
        });

        // Button can only be "selected" if URL has the same number of filter params
        if (urlFilterParamCount !== btnFilterParamCount) {
            setButtonAriaState($btn, false);
            return;
        }

        // All button params must match URL params
        var isSelected = true;
        buttonParams.forEach(function (value, key) {
            var urlValue = normaliseFilterValue(selectedFilters.get(key));
            if (!urlValue) {
                isSelected = false;
                return;
            }
            // Handle %7C-separated multi-values
            var urlValues = urlValue.split('%7C');
            var btnValues = normaliseFilterValue(value).split('%7C');
            btnValues.forEach(function (bv) {
                if (!urlValues.includes(bv)) {
                    isSelected = false;
                }
            });
        });

        setButtonAriaState($btn, isSelected);
    });
}

/**
 * #5 fix: build the URL that clears all quick-filter params (for toggle-off).
 * @returns {string} The current URL with all prefn/prefv params removed
 */
function buildClearFilterUrl() {
    var currentUrl = new URL(window.location.href);
    var params = currentUrl.searchParams;
    var keysToDelete = [];
    params.forEach(function (value, key) {
        if (key.startsWith('prefn') || key.startsWith('prefv')) {
            keysToDelete.push(key);
        }
    });
    keysToDelete.forEach(function (key) { params.delete(key); });
    params.delete('start');
    return currentUrl.toString();
}

/**
 * Build the URL that applies a button's filter params (for toggle-on).
 * #15 fix: we do NOT use URLSearchParams to parse+re-serialize the filter values,
 * because URLSearchParams encodes spaces as + on serialization, but SFCC expects %20.
 * Instead we strip existing filter params from the URL and directly append the
 * normalised filter string.
 * @param {jQuery} $btn - The filter button jQuery element
 * @returns {string|null} URL with button filter params applied, or null if no filter data
 */
function buildApplyFilterUrl($btn) {
    var filterData = $btn.data('filter');
    if (!filterData) return null;

    // Normalise: &amp; → &, + → %20 (spaces must be percent-encoded for SFCC)
    var normalisedFilter = filterData
        .replace(/&amp;/g, '&')
        .replace(/\+/g, '%20');

    // Strip existing prefn/prefv params and 'start' from current URL
    var currentUrl = new URL(window.location.href);
    var keysToDelete = [];
    currentUrl.searchParams.forEach(function (value, key) {
        if (key.startsWith('prefn') || key.startsWith('prefv') || key === 'start') {
            keysToDelete.push(key);
        }
    });
    keysToDelete.forEach(function (key) { currentUrl.searchParams.delete(key); });

    // Directly append the normalised filter string to preserve %20 encoding.
    // Keep URL fragment/hash at the end. Anything after # is treated as the
    // fragment, so query params appended after it would be ignored by SFCC.
    var hash = currentUrl.hash;
    currentUrl.hash = '';

    var baseUrl = currentUrl.toString();
    var separator = currentUrl.search ? '&' : '?';
    return baseUrl + separator + normalisedFilter + hash;
}

/**
 * Pre-compute aria-label data attributes so JS doesn't need to call
 * server-side resource strings (they were rendered in the HTML as
 * initial aria-label, but we store the two variants for toggling).
 * We derive them from the initial aria-label (label-off) and a
 * data-title fallback.
 */
function initAriaLabels() {
    $(FILTER_BTN_SELECTOR).each(function () {
        var $btn = $(this);
        if (!$btn.data('label-off')) {
            var title = $btn.text().trim();
            // Use the initial aria-label from server rendering as the "off" label
            var labelOff = $btn.attr('aria-label') || ('Filter by ' + title + ' and clear other filters');
            var labelOn = 'Remove ' + title + ' filter';
            $btn.data('label-off', labelOff);
            $btn.data('label-on', labelOn);
        }
    });
}

function filterButtonsUpdated() {
    handleFilterButtonsDisable();
    updateFilterButtonStates();
}

$(document).on('custom:filter:buttons:updated', filterButtonsUpdated);

// Init aria labels on page load
$(document).ready(function () {
    initAriaLabels();
});

module.exports = {
    handleFilterButtonsDisable: handleFilterButtonsDisable,
    updateFilterButtonStates: updateFilterButtonStates,
    buildClearFilterUrl: buildClearFilterUrl,
    buildApplyFilterUrl: buildApplyFilterUrl
};
